import React, { Component } from "react";
import styled, { css } from "react-emotion";

import { Form, Input, Icon, Button } from "antd";

// -------------------------------- Styles
const CardWrapper = styled("div")({
  border: "1px solid #eee",
  borderRightStyle: "hidden",
  marginBottom: "30px",
  padding: "5px"
});

const Title = styled("div")({
  fontWeight: "bold",
  marginBottom: 0,
  button: {
    marginLeft: "10px"
  }
});

const InputContainer = styled("div")({});
const Span = styled("span")({
  marginLeft: "10px"
});

const Text = styled("div")({
  display: "inline-block",
  width: "50%"
});

const AddButton = styled("div")({
  display: "inline-block"
});
// ----------------------------------------------

let id = 1;

class DynamicForm extends Component {
  remove = (k, index) => {
    const { form, onRemoveInput } = this.props;
    const keys = form.getFieldValue("keys");
    if (keys.length === 1) {
      return;
    }
    form.setFieldsValue({
      keys: keys.filter(key => key !== k)
    });
    onRemoveInput(index);
  };

  add = () => {
    const { name, form, onAddInput } = this.props;
    const keys = form.getFieldValue("keys");
    const nextKeys = keys.concat(id++);
    form.setFieldsValue({
      keys: nextKeys
    });
    onAddInput({ name, id });
  };

  onchange = (name, value, index) => {
    const { maxCharLength, onChangeValue } = this.props;
    if (maxCharLength >= value.length) {
      onChangeValue(name, value, index);
    }
  };

  renderAddItem = () => (
    <Button
      type="ghost"
      shape="circle"
      icon="plus"
      size="small"
      title={`Add ${this.props.label}`}
      onClick={this.add}
    />
  );

  renderRemoveItem = (k, index) => (
    <Icon
      className={css({ marginLeft: 10 })}
      title={`Remove ${this.props.label}`}
      type="minus-circle-o"
      onClick={() => this.remove(k, index)}
    />
  );

  renderInput = (keys, key, index) => {
    const { label, name, values, maxCharLength } = this.props;
    return (
      <InputContainer>
        <Input
          name={name}
          placeholder={`${label} ${index + 1}`}
          value={values[index]}
          onChange={e => {
            this.onchange(e.target.name, e.target.value, index);
          }}
          style={{ width: "75%" }}
        />
        <Span>
          {values[index].length}/{maxCharLength}
        </Span>
        {keys.length > 1 ? this.renderRemoveItem(key, index) : null}
      </InputContainer>
    );
  };

  render() {
    const { title, maxFieldsLength, maxCharLength, form } = this.props;
    const { getFieldDecorator, getFieldValue } = form;
    getFieldDecorator("keys", { initialValue: [0] });
    const keys = getFieldValue("keys");

    return (
      <CardWrapper>
        <Title>
          <Text>{title}</Text>
          <AddButton>
            {keys.length === maxFieldsLength ? null : this.renderAddItem()}{" "}
          </AddButton>
        </Title>
        <Form>
          {keys.map((key, index) => (
            <Form.Item required={false} key={key}>
              {getFieldDecorator(`names[${key}]`, {
                validateTrigger: ["onChange", "onBlur"],
                rules: [
                  {
                    max: maxCharLength,
                    required: true,
                    whitespace: true,
                    message: " "
                  }
                ],
                initialValue: ""
              })(this.renderInput(keys, key, index))}
            </Form.Item>
          ))}
        </Form>
      </CardWrapper>
    );
  }
}

export default Form.create({ name: "dynamic_form_item" })(DynamicForm);
